import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";

interface ConfirmStepProps {
  targetType: string;
  file: File | undefined;
}

const SummaryRow: React.FC<{ label: string; value: string }> = ({ label, value }) => (
  <Box display="flex" justifyContent="space-between" alignItems="center" gap={2} py={1}>
    <Typography variant="body2" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="body2" fontWeight={600} sx={{ textAlign: "right", wordBreak: "break-word" }}>
      {value}
    </Typography>
  </Box>
);

export const ConfirmStep: React.FC<ConfirmStepProps> = ({ targetType, file }) => (
  <Grid container spacing={2.5} direction="column">
    <Grid item>
      <Typography variant="body2" color="text.secondary">
        Review and confirm the migration settings.
      </Typography>
    </Grid>

    <Grid item>
      <Box sx={{ bgcolor: "action.hover", borderRadius: 1, px: 2, py: 0.5 }}>
        <SummaryRow label="Target" value={targetType} />
        <Divider />
        <SummaryRow
          label="Lease number override"
          value={file ? file.name : "None — using current data"}
        />
      </Box>
    </Grid>

    <Grid item>
      <Typography variant="body2" color="warning.main">
        This action cannot be undone. Make sure all settings are correct before proceeding.
      </Typography>
    </Grid>
  </Grid>
);
